import { readFileSync } from 'fs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

interface IGetIP {
    ip: string
    network: string
    version: string
    city: string
    region: string
    region_code: string
    country: string
    country_name: string
    country_code: string
    country_code_iso3: string
    country_capital: string
    country_tld: string
    continent_code: string
    in_eu: boolean
    postal: string
    latitude: number
    longitude: number
    timezone: string
    utc_offset: string
    country_calling_code: string
    currency: string
    currency_name: string
    languages: string
    country_area: number
    country_population: number
    asn: string
    org: string
}

@Injectable({ providedIn: 'root' })
export class CertificatesService {

    constructor(private http: HttpClient) { }

    getCertificates(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/certificates/`, body, { headers });
    }

    getDetailCertificates(id, data = {lpo: '', cor: ''}, documentId = '') {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };
        
        const body = {
            certificateNumberLPO: data.lpo,
            certificateNumberOPR: data.cor,
            documentId: documentId,
        }

        return this.http.post<any>(`${environment.apiUrl}/certificates/${id}`, body, { headers });
    }

    regeneratePDFCertificates(recordId, certificateId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            certificateId: certificateId
        }

        return this.http.post<any>(`${environment.apiUrl}/certificates/regeneratePdf/${recordId}`, body, { headers });
    }

    getUrlStatus(url: string) {
        return this.http.get(url);
    }

    getCertificatesHistory(evaluationId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/certificates/getJSONs/${evaluationId}`, { headers });

    }

    getFormCertificate(evaluationId, formId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/certificates/getFormCertificate/${evaluationId}/form/${formId}`, { headers });
    }

    saveFormCertificate(data) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.post<any>(`${environment.apiUrl}/certificates/saveFormCertificate`, data, { headers });
    }

    // typeDownload 4, 5 (Descargas operador, descargas metrocert)
    registerDownloadCertificate(evaluationId, typeDownload, typeCertificate, data = {lpo: '', cor: ''}) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Authorization': jwtToken
        };

        const body = {
            certificateNumberLPO: data.lpo,
            certificateNumberOPR: data.cor,
        }

        return this.http.post(`${environment.apiUrl}/certificates/downloadMetrocert/${evaluationId}/${typeDownload}/${typeCertificate}`, body, { headers, responseType: 'blob' as 'blob', observe: 'response' });
    }

    //typeDownload 1, 2, 3 (QR, URL, Shared Operator)
    registerDownload(evaluationId, typeDownload, typeCertificate, data = {lpo: '', cor: ''}, signature) {
        const body = {
            certificateNumberLPO: data.lpo,
            certificateNumberOPR: data.cor,
            signature: signature
        }

        return this.http.post(`${environment.apiUrl}/certificates/download/${evaluationId}/${typeDownload}/${typeCertificate}`, body, { responseType: 'blob' as 'blob', observe: 'response' });
    }

    getAllCertificatesUE(evaluationId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/certificates/ue/${evaluationId}`, { headers });
    }

    updateCertificateUE(evaluationId, formData) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Authorization': jwtToken
        };

        return this.http.patch<any>(`${environment.apiUrl}/certificates/ue/${evaluationId}`, formData, { headers });
    }

    getIP() {
        return this.http.get<IGetIP>("https://ipapi.co/json")
    }

    /* getPosition(ip) {
        const headers = {
            'Content-Type': 'application/json'
        };

        return this.http.get<any>(`https://ipapi.co/${ip}/json`, { headers })
    } */
}